import co from "../locales/co.json";
import es from "../locales/es.json";
import en from "../locales/en.json";

type Lang = "co" | "es" | "en";
const resources = { co, es, en };

// idioma actual (inicialmente detectado desde URL)
let currentLang: Lang = detectLanguageFromURL();

// Detecta idioma desde la ruta del navegador
function detectLanguageFromURL(): Lang {
  const path = window.location.pathname; 
  const segments = path.split("/");
  const lang = segments[1] as Lang;
  if (resources[lang]) return lang;
  return "co"; // fallback
}

// Cambiar idioma manualmente
export const setLanguage = (lang: Lang) => {
  if (resources[lang]) currentLang = lang;
};

// Obtener traducción
export const t = (key: string) => {
  const keys = key.split(".");
  let value: any = resources[currentLang];

  for (let k of keys) {
    value = value?.[k];
    if (!value) return key;
  }

  return value;
};
